import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Button from '@starbucks-web/pattern-library/lib/components/button';
import Icon from '@starbucks-web/pattern-library/lib/components/icon';
import plusPath from '@starbucks-web/pattern-library/lib/icons/plus';

import styles from './styles.cssm';

/* eslint-disable no-shadow */
const AddCardButton = ({ className, ...otherProps }) => (
  <Button
    className={`block size12of12 color-textBlackSoft text-center ${
      styles.base
    } ${className || ''}`}
    tagName={Link}
    to="/account/cards/add"
    visualStyle="textLink"
    {...otherProps}
    data-e2e="addCardButton"
  >
    <span className={'absoluteCenter size12of12'}>
      <Icon className="mr2" path={plusPath} />
      <FormattedMessage
        defaultMessage="Add card"
        description="Button to add a Stored Value Card to the user`s account"
        id="accountCards.addCardButton.addCardButton"
      />
    </span>
  </Button>
);

export default AddCardButton;
